import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CreateVehicleDto } from "./dto/createVehicleDto";
import { Observable } from "rxjs";
import { RestResponse } from "../../shared/RestResponse";
import { ListVehicleDto } from "./dto/listVehicleDto";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class VehicleService {
  private readonly baseUrl = `${environment.base_url}/vehicles`;

  constructor(private http: HttpClient) {}

  create(dto: CreateVehicleDto): Observable<RestResponse<void>> {
    return this.http.post<RestResponse<void>>(`${this.baseUrl}/create`, dto);
  }

  list(search: string, active: boolean | null, driverId: number | null, page: number): Observable<RestResponse<ListVehicleDto[]>> {
    let params: any = { page };
    
    if (search) {
      params.search = search;
    }
    if (active !== null) {
      params.active = active;
    }
    if (driverId) {
      params.driverId = driverId;
    }

    return this.http.get<RestResponse<ListVehicleDto[]>>(`${this.baseUrl}/list`, {params});
  }

  update(id: number, dto: CreateVehicleDto): Observable<RestResponse<CreateVehicleDto>> {
    return this.http.put<RestResponse<CreateVehicleDto>>(`${this.baseUrl}/update/${id}`, dto);
  }

  delete(id: number): Observable<RestResponse<void>> {
    return this.http.delete<RestResponse<void>>(`${this.baseUrl}/delete/${id}`);
  }

  getById(id: number): Observable<RestResponse<ListVehicleDto>> {
    return this.http.get<RestResponse<ListVehicleDto>>(`${this.baseUrl}/find/${id}`);
  }
}